export default "data:image/webp;base64,UklGRkQAAABXRUJQVlA4TDcAAAAvJ8AEAFDSRhK0Is/JOTqjx/ZBSwUChEj+UxBk28xoMkO5//s/ARhyMdzItTDzP9zIWJgBhHsAAA=="